import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";

import { useMasterHoldMaintenanceVM } from "presentation/hook/MasterHold/useMasterHoldMaintenanceVM";
import { useMasterHoldMaintenanceTracked } from "presentation/store/MasterHold/MasterHoldMaintenanceProvider";
import { MasterHoldHeaderFormPanel } from "./Form/MasterHoldHeaderFormPanel";
import MasterHoldDetailTablePanel from "./Table/MasterHoldDetailTablePanel";

export const MasterHoldEditPanel: React.FC = () => {
    const [masterHoldState] = useMasterHoldMaintenanceTracked();
    const masterHoldVM = useMasterHoldMaintenanceVM();
    const { isShowDetail } = masterHoldState;
    const masterHoldEty = masterHoldState.currentSelectedRow;

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isShowDetail) {
            const initialScreen = async () => {
                setIsLoading(true);
                try {
                    const results = await Promise.allSettled([
                        masterHoldEty?.id && masterHoldVM.searchChargeInfo(masterHoldEty.id)
                    ]);
                    results?.forEach((result, index) => {
                        if (index === 0 && result.status === 'fulfilled') {

                        }
                    })
                } catch (error) {
                    setIsLoading(false);
                }
            }
            initialScreen().then(() => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }
    }, [isShowDetail, masterHoldEty.id, masterHoldVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <div className='main-comp-wrapper'>
        <SliderPanel
            isOpen={true}
            leftSectionWidth={'35%'}
            rightSectionWidth={'65%'}
            draggable={false}
            leftChildren={<MasterHoldHeaderFormPanel />}
            rightChildren={<MasterHoldDetailTablePanel />}
        />
    </div>
}

export default memo(MasterHoldEditPanel);